interface JwtPayload {
  [key: string]: any;
}

/**
 * Decodifica um token JWT e extrai um campo específico do payload
 * @param token O token JWT completo
 * @param fieldName Nome do campo a ser extraído do payload
 * @returns O valor do campo solicitado ou null se o token for inválido ou o campo não existir
 */
export function extractJwtField<T>(token: string, fieldName: string): T | null {
  try {
    if (!token) {
      console.error('Token não fornecido');
      return null;
    }

    const parts = token.split('.');

    if (parts.length !== 3) {
      console.error('Formato de token inválido');
      return null;
    }

    const base64Payload = parts[1];

    const base64 = base64Payload.replace(/-/g, '+').replace(/_/g, '/');

    const paddedBase64 = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '='
    );

    const rawPayload = atob(paddedBase64);

    const decodedPayload = decodeURIComponent(
      Array.from(rawPayload)
        .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    const payload: JwtPayload = JSON.parse(decodedPayload);

    if (!(fieldName in payload)) {
      console.error(`Campo '${fieldName}' não encontrado no payload do token`);
      return null;
    }

    return payload[fieldName] as T;
  } catch (error) {
    console.error('Erro ao processar o token JWT:', error);
    return null;
  }
}

/**
 * Função auxiliar para extrair facilmente o campo SID específico
 * @param token O token JWT
 * @returns O valor do campo SID ou null
 */
export function extractSidFromJwt(token: string): string | null {
  return extractJwtField<string>(token, 'sid');
}
